var map = {
	"./estilo de gestión.svg": 686,
	"./iconos/bancolombia-pe-003-active.svg": 359,
	"./iconos/bancolombia-pe-003-normal.svg": 360,
	"./iconos/bancolombia-pe-004-active.svg": 361,
	"./iconos/bancolombia-pe-004-normal.svg": 362,
	"./iconos/bdb-entreview-ico-blue-2.svg": 687,
	"./iconos/bdb-entreview-ico-blue.svg": 688,
	"./iconos/bdb-entreview-ico-gray.svg": 689,
	"./iconos/bdb-entreview-ico-gray2.svg": 690,
	"./liderazgo.svg": 691,
	"./números.svg": 692,
	"./partes.svg": 693,
	"./percepción.svg": 694,
	"./razonamiento.svg": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;